<template>
  <div>
    <h1 class="mb-8 text-xl font-bold text-primary">
      Paiement via Stripe
    </h1>

    <div class="mt-8">
      <div class="flex items-center">
        <div>
          <h3 class="font-bold">
            Carte de crédit
          </h3>
          <p class="mt-2 text-gray-600">
            Le paiement est sécurisé et assuré via <a
              class="underline"
              href="https://stripe.com/fr"
            >Stripe</a>. Nous acceptons les cartes Mastercard et Visa.
          </p>
        </div>
        <div class="flex ml-auto flex-nowrap">
          <img
            alt="mastercard"
            src="@/assets/billing/mastercard.png"
            class="h-8 mr-2"
          >
          <img
            alt="visa"
            src="@/assets/billing/visa.png"
            class="h-8"
          >
        </div>
      </div>

      <div
        class="w-full px-3 pt-2 pb-2 mt-5 text-gray-500 border-b border-gray-400 outline-none bg-light-gray"
        data-target="stripe.card"
      />

      <div
        v-if="error"
        class="w-full mt-2 font-bold text-danger"
      >
        {{ error }}
      </div>
    </div>

    <div class="mt-8 text-right">
      <t-submit-button
        type="button"
        :button-state="buttonState"
        :labels="{ default: 'Payer', inProgress: 'Paiement en cours', success: 'Paiement avec Succès !', fail: 'Échec' }"
        :disabled="!isReady"
        @click="pay"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import * as OrderService from '@/services/order';
import { STRIPE_PUBLISHABLE_KEY } from '@/shared/config';

export default {
  name: 'StripePaymentForm',
  data() {
    return {
      paymentInformation: null,
      buttonState: 'default',
      stripeAPIToken: STRIPE_PUBLISHABLE_KEY,
      stripe: null,
      elements: null,
      card: null,
      error: null
    };
  },
  async mounted() {
    this.includeStripe('js.stripe.com/v3/', () => this.configureStripe());
    this.paymentInformation = await OrderService.create(this.legalAd);

    // If the user has already entered their billing address, we need to set it in the paymentInformation
    if (this.paymentInformation.addressAttributes) {
      this.setAddressAttributes(this.paymentInformation.addressAttributes);
    }
  },
  computed: {
    ...mapState(['legalAd']),
    isReady() {
      return this.buttonState === 'default' && this.paymentInformation && this.stripe && this.card;
    },
  },
  methods: {
    ...mapActions(['stopEditingLegalAd', 'setTouched', 'changeLegalAdBillingAddress']),
    setAddressAttributes(addressAttributes) {
      this.changeLegalAdBillingAddress({ changes: addressAttributes });
    },
    pay() {
      if (!this.isReady) return false;
      this.buttonState = 'inProgress';

      this.stripe.confirmCardPayment(this.paymentInformation.paymentSecret, {
        payment_method: {
          card: this.card,
          billing_details: {
            name: this.currentAccount.fullName,
            email: this.currentAccount.email
          }
        }
      }).then(result => {
        if (result.error) {
          // Show error to your customer (e.g., insufficient funds)
          this.buttonState = 'fail';
          this.error = result.error?.message;
        } else {
          // The payment has been processed!
          if (result.paymentIntent.status === 'succeeded') {
            OrderService.update(result.paymentIntent.id, this.legalAd?.addressAttributes).then(() => {
              this.stopEditingLegalAd();
              this.$router.push({
                name: 'myLegalAds',
                params: { payment: true }
              });
              this.setTouched(false);
            })
            .catch(() => this.buttonState = 'fail');
          }
        }
      }).catch(error => {
        console.log('Stripe error', error);
      });
    },
    includeStripe(URL, callback ){
      const documentTag = document, tag = 'script',
          object = documentTag.createElement(tag),
          scriptTag = documentTag.getElementsByTagName(tag)[0];
      object.src = '//' + URL;
      if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
      scriptTag.parentNode.insertBefore(object, scriptTag);
    },
    configureStripe(){
      this.stripe = window.Stripe(this.stripeAPIToken, { locale: 'fr' });
      const style = {
        base: {
          // Add your base input styles here. For example:
          fontSize: '16px',
          color: '#32325d',
        }
      };

      this.elements = this.stripe.elements();
      this.card = this.elements.create('card', { style });

      this.card.addEventListener('change', ({ error }) => {
        this.error = error?.message;
        this.buttonState = error ? 'fail' : 'default';
      });
      this.card.mount(this.$el.querySelectorAll('[data-target="stripe.card"]')[0]);
    },
  },
};
</script>
